import React from 'react';
import PropTypes from 'prop-types';

const StudentNameCell = ({ lastName, firstName }) => (
    <div className="name-container flexible">
        <div className="student-name">
            <strong>{lastName}</strong>, {firstName}
        </div>
    </div>
);

StudentNameCell.defaultProps = {
    lastName: '',
    firstName: '',
};

StudentNameCell.propTypes = {
    lastName: PropTypes.string,
    firstName: PropTypes.string,
};
export default StudentNameCell;
